import React, { Component } from "react";
import { connect } from "react-redux";
import { getActiveSliders } from "../../store/actions/slider";
import ModernCarousel from "../../components/Carousel";
import CategoryNavigation from "../../components/shared/CategoryNavigation";
import CategoryShowcase from "../../components/CategoryShowcase";
import LazyComponent from "../../components/shared/LazyComponent";
import LoadingFallback from "../../components/shared/LoadingFallback";
import ErrorBoundary from "../../components/shared/ErrorBoundary";
import SEO from "../../components/shared/SEO";
import {
  PERFORMANCE_CONFIG,
  shouldLazyLoad,
  getLoadingVariant,
} from "../../config/performance";
import {
  generatePageTitle,
  generateMetaDescription,
  generateKeywords,
} from "../../helpers/seo";

class Home extends Component {
  componentDidMount() {
    this.props.getActiveSliders();
  }
  render() {
    const { activeSliders, fetchingActiveSliders, setting } = this.props;

    // SEO data for home page
    const homePageSEO = {
      title: generatePageTitle(
        "home",
        null,
        setting && setting.setting && setting.setting.title
      ),
      description: generateMetaDescription(
        "home",
        null,
        setting && setting.setting && setting.setting.title
      ),
      keywords: generateKeywords("home", null, [
        "e-ticaret",
        "online alışveriş",
        "doğal kozmetik",
      ]),
      type: "website",
      url: "/",
      structuredData: {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name:
          (setting && setting.setting && setting.setting.title) || "Botaniksan",
        url:
          process.env.NODE_ENV === "development"
            ? "http://localhost:3000"
            : "https://botaniksan.com",
        potentialAction: {
          "@type": "SearchAction",
          target: {
            "@type": "EntryPoint",
            urlTemplate:
              process.env.NODE_ENV === "development"
                ? "http://localhost:3000/arama?q={search_term_string}"
                : "https://botaniksan.com/arama?q={search_term_string}",
          },
          "query-input": "required name=search_term_string",
        },
      },
    };

    return (
      <ErrorBoundary>
        <React.Fragment>
          <SEO {...homePageSEO} />
          {/* Hero Slider - Critical above-the-fold content */}
          {activeSliders && activeSliders.length > 0 && (
            <ModernCarousel sliders={activeSliders} />
          )}

          {/* Category Navigation - Critical for navigation */}
          <CategoryNavigation />

          {/* Category Showcase - Load immediately as it's near top */}
          <CategoryShowcase />

          {/* Featured Products - Conditional lazy loading */}
          {shouldLazyLoad("featured") ? (
            <LazyComponent
              loader={() => import("../../components/FeaturedProducts")}
              fallback={
                <LoadingFallback
                  variant={getLoadingVariant("featured")}
                  height="400px"
                  message="Öne çıkan ürünler yükleniyor..."
                />
              }
              rootMargin={
                PERFORMANCE_CONFIG.lazyLoading.components.featured.rootMargin
              }
              minHeight="400px"
            />
          ) : (
            <LazyComponent
              loader={() => import("../../components/FeaturedProducts")}
              lazy={false}
              fallback={
                <LoadingFallback
                  variant="minimal"
                  height="400px"
                  message="Yükleniyor..."
                />
              }
            />
          )}

          {/* Best Seller Products - Lazy load */}
          <LazyComponent
            loader={() => import("../../components/BestSellerProducts")}
            fallback={
              <LoadingFallback
                variant="skeleton"
                height="400px"
                message="Çok satan ürünler yükleniyor..."
              />
            }
            rootMargin="150px 0px"
            minHeight="400px"
          />

          {/* Deal Products Slider - Lazy load */}
          <LazyComponent
            loader={() => import("../../components/DealProductsSlider")}
            fallback={
              <LoadingFallback
                variant="skeleton"
                height="350px"
                message="Fırsat ürünleri yükleniyor..."
              />
            }
            rootMargin="100px 0px"
            minHeight="350px"
          />

          {/* Discounted Products - Lazy load */}
          <LazyComponent
            loader={() => import("../../components/DiscountedProducts")}
            fallback={
              <LoadingFallback
                variant="skeleton"
                height="400px"
                message="İndirimdeki ürünler yükleniyor..."
              />
            }
            rootMargin="100px 0px"
            minHeight="400px"
            maxItems={8}
          />

          {/* Recently Added Products - Lazy load with lower priority */}
          <LazyComponent
            loader={() => import("../../components/RecentlyAddedProducts")}
            fallback={
              <LoadingFallback
                variant="skeleton"
                height="400px"
                message="Yeni eklenen ürünler yükleniyor..."
              />
            }
            rootMargin="50px 0px"
            minHeight="400px"
          />

          {/* Footer Top - Lazy load as it's at bottom */}
          {/* <LazyComponent
            loader={() => import("../../components/shared/FooterTop")}
            fallback={
              <LoadingFallback 
                variant="minimal" 
                height="200px"
              />
            }
            rootMargin="0px 0px"
            minHeight="200px"
          /> */}
        </React.Fragment>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state) => ({
  activeSliders: state.slider.activeSliders,
  fetchingActiveSliders: state.slider.fetchingActiveSliders,
  categoryNavigation: state.categoryNavigation,
  categoryShowcase: state.categoryShowcase,
  setting: state.setting,
});

const mapDispatchToProps = {
  getActiveSliders,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/routers/Home/index.js